import { Card, Flex, Input, Radio, Typography } from "antd"
import RadioButton from "../../common/RadioButton"
import { checkNumberLengthError, ManualPaymentMethod } from "./payInvoiceModel"

type Props = {
  manualPaymentMethod: ManualPaymentMethod
  onManualPaymentMethodChange: (method: ManualPaymentMethod) => void
  checkNumber: string
  onCheckNumberChange: (checkNumber: string) => void
  documentLabel?: string
}

const PaymentTypeCard = ({ manualPaymentMethod, onManualPaymentMethodChange, checkNumber, onCheckNumberChange, documentLabel = 'Invoice' }: Props) => {
  const lengthError = manualPaymentMethod === 'check' ? checkNumberLengthError(checkNumber) : undefined

  return <Card
    title={<div style={{ margin: "16px 0" }}>
      Payment Type
      <br/>
      <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>
        Select how the {documentLabel.toLowerCase()} was paid.
      </Typography.Text>
    </div>}
  >
    <Radio.Group value={manualPaymentMethod} onChange={x => onManualPaymentMethodChange(x.target.value)} style={{ width: '100%' }}>
      <Flex gap={8}>
        <div style={{ width: '100%' }}>
          <RadioButton
            value="cash"
            checked={manualPaymentMethod === 'cash'}
            onBorderClick={() => onManualPaymentMethodChange('cash')}
          >Cash</RadioButton>
        </div>
        <div style={{ width: '100%' }}>
          <RadioButton
            value="check"
            checked={manualPaymentMethod === 'check'}
            onBorderClick={() => onManualPaymentMethodChange('check')}
          >Check</RadioButton>
        </div>
      </Flex>
    </Radio.Group>
    <div style={{
      display: 'grid',
      gridTemplateRows: manualPaymentMethod === 'check' ? '1fr' : '0fr',
      transition: 'grid-template-rows 200ms ease'
    }}>
      <div style={{ overflow: 'hidden' }}>
        <div style={{ paddingTop: '16px' }}>
          <Typography.Text>Check Number</Typography.Text>
          <Input
            aria-label="Check Number"
            aria-invalid={!!lengthError}
            aria-describedby={lengthError ? 'check-number-error' : undefined}
            status={lengthError ? 'error' : undefined}
            value={checkNumber}
            onChange={e => onCheckNumberChange(e.target.value)}
            placeholder="Check Number"
          />
          {lengthError && <Typography.Text id="check-number-error" type="danger" role="alert">
            {lengthError}
          </Typography.Text>}
        </div>
      </div>
    </div>
  </Card>
}

export default PaymentTypeCard
